"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTextareaHeight = void 0;

var getTextareaHeight = function getTextareaHeight() {
  var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var el = arguments.length > 1 ? arguments[1] : undefined;

  var _window$getComputedSt = window.getComputedStyle(el),
      borderBottomWidth = _window$getComputedSt.borderBottomWidth,
      borderTopWidth = _window$getComputedSt.borderTopWidth,
      lineHeight = _window$getComputedSt.lineHeight,
      paddingBottom = _window$getComputedSt.paddingBottom,
      paddingTop = _window$getComputedSt.paddingTop;

  var rowHeight = rows === null ? 0 : parseFloat(lineHeight) * parseInt(rows, 10) + parseFloat(borderBottomWidth) + parseFloat(borderTopWidth) + parseFloat(paddingBottom) + parseFloat(paddingTop);
  var scrollHeight = el.scrollHeight + parseFloat(borderBottomWidth) + parseFloat(borderTopWidth);
  return Math.max(rowHeight, scrollHeight);
};

exports.getTextareaHeight = getTextareaHeight;